export type AlertLevel = {
  rainMin10: number
  rainMin60: number
  waterLevel: number
  moveRainMin10: number
  moveRainMin60: number
  rainDay: number
  maxMoveRainMin10OfDay: number
  maxMoveRainMin10OfDayTime: string
  maxMoveRainMin60OfDay: number
  maxMoveRainMin60OfDayTime: string
  rainRui: number
}

export type HistoryItem = {
  time: string
  rainMin10: number
  rainMin60: number
  waterLevel: number
  rainDay: number
  rainRui: number
  moveRainMin10: number
  moveRainMin60: number
  maxMoveRainMin10OfDay: number
  maxMoveRainMin10OfDayTime: string
  maxMoveRainMin60OfDay: number
  maxMoveRainMin60OfDayTime: string
  alertLevel: AlertLevel
  moveWdMin10?: number
  moveWsMin10?: number
  moveMaxWdMin10?: number
  moveMaxWsMin10?: number
  humid1?: number
  press1?: number
  temp?: number
}

export type HistoryAttributes = {
  stationId: string
  items: HistoryItem[]
}

export default class History {
  public stationId: string
  public items: HistoryItem[]

  constructor(public attributes: HistoryAttributes) {
    this.stationId = attributes.stationId
    this.items = attributes.items
  }
}
